export default __webpack_public_path__ + "static/media/fryed-cheese-sticks.777ef6da.jpg";